var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3009_23534)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 28,
    height: 24,
    rx: 12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11.6666C19 10.562 19.8954 9.66659 21 9.66659C22.1046 9.66659 23 10.562 23 11.6666C23 12.7712 22.1046 13.6666 21 13.6666C19.8954 13.6666 19 12.7712 19 11.6666ZM21 8.33325C19.1591 8.33325 17.6667 9.82564 17.6667 11.6666C17.6667 13.5075 19.1591 14.9999 21 14.9999C22.8409 14.9999 24.3333 13.5075 24.3333 11.6666C24.3333 9.82564 22.8409 8.33325 21 8.33325ZM25.0208 8.92115C25.1122 8.56446 25.4753 8.34935 25.832 8.44067C26.549 8.62426 27.1846 9.04126 27.6384 9.62593C28.0922 10.2106 28.3386 10.9297 28.3386 11.6698C28.3386 12.41 28.0922 13.1291 27.6384 13.7137C27.1846 14.2984 26.549 14.7154 25.832 14.899C25.4753 14.9903 25.1122 14.7752 25.0208 14.4185C24.9295 14.0618 25.1446 13.6987 25.5013 13.6073C25.9315 13.4972 26.3128 13.247 26.5851 12.8962C26.8574 12.5454 27.0052 12.1139 27.0052 11.6698C27.0052 11.2258 26.8574 10.7943 26.5851 10.4435C26.3128 10.0927 25.9315 9.84249 25.5013 9.73234C25.1446 9.64101 24.9295 9.27783 25.0208 8.92115ZM18.3333 16.3333C17.4493 16.3333 16.6014 16.6844 15.9763 17.3096C15.3512 17.9347 15 18.7825 15 19.6666V20.9999C15 21.3681 15.2985 21.6666 15.6667 21.6666C16.0349 21.6666 16.3333 21.3681 16.3333 20.9999V19.6666C16.3333 19.1362 16.544 18.6274 16.9191 18.2524C17.2942 17.8773 17.8029 17.6666 18.3333 17.6666H23.6667C24.1971 17.6666 24.7058 17.8773 25.0809 18.2524C25.456 18.6274 25.6667 19.1362 25.6667 19.6666V20.9999C25.6667 21.3681 25.9651 21.6666 26.3333 21.6666C26.7015 21.6666 27 21.3681 27 20.9999V19.6666C27 18.7825 26.6488 17.9347 26.0237 17.3096C25.3986 16.6844 24.5507 16.3333 23.6667 16.3333H18.3333ZM28.5 16.441C28.1435 16.349 27.7799 16.5633 27.6878 16.9198C27.5958 17.2763 27.8102 17.64 28.1667 17.732C28.5957 17.8428 28.9759 18.0929 29.2473 18.4432C29.5188 18.7933 29.6663 19.2239 29.6667 19.667V20.9998C29.6667 21.368 29.9651 21.6665 30.3333 21.6665C30.7015 21.6665 31 21.368 31 20.9998V19.666C30.9994 18.9274 30.7536 18.21 30.3011 17.6263C29.8486 17.0426 29.2151 16.6256 28.5 16.441Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 2.5,
    width: 29,
    height: 25,
    rx: 12.5,
    stroke: "#7098A7",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3009_23534",
    x: 0,
    y: 0,
    width: 46,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.796078 0 0 0 0 0.827451 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3009_23534"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.796078 0 0 0 0 0.827451 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3009_23534",
    result: "effect2_dropShadow_3009_23534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3009_23534",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtIcon);
export default __webpack_public_path__ + "static/media/bt-icon.2a707f5d9d9ef97cdc4d4d28de736fc0.svg";
export { ForwardRef as ReactComponent };